import { Map as ImmutableMap, Record } from 'immutable';

// ////////////////////////////////////////////////////////////////////////////////////////////////
// Biller Account - Base Biller Account Properties
// ////////////////////////////////////////////////////////////////////////////////////////////////

export const mkBillerAccount = Record({
  id: undefined,
  createdAt: undefined,
  modifiedAt: undefined,

  providerBillerAccountID: undefined,

  billerLoginID: undefined,
  name: undefined,
  nickName: undefined,

  isHidden: false,
  isPayable: false,
});

// ================================================================================================
// BillerAccountsStore - Biller Accounts Store Properties & Types
// ================================================================================================

export const mkBillerAccountStore = Record({
  resourcesById: ImmutableMap(),
  lastSyncDate: undefined,

  loadPending: true,
  isLoading: false,

  error: null,

  isRefreshing: false,
});
